import { styled } from '@mui/material/styles';

export const StyledProposalButton = styled('button')(({ theme }) => ({
  width: '100%',
  height: '9.6rem',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  border: `0.1rem solid ${theme.colors.base05}`,

  borderRadius: '1rem',
  backgroundColor: theme.colors.base06,

  color: theme.colors.base01,

  padding: '1.6rem',

  '&:hover': {
    border: `0.1rem solid ${theme.colors.base01}`,
  },

  '&:disabled': {
    border: 'none',
  },
}));

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const IconContainer = styled('div')({
  width: '4.8rem',
  height: '4.8rem',

  '& > svg': {
    width: '4.8rem',
    height: '4.8rem',
  },
});

export const LeftContainer = styled('div')({
  height: '100%',

  display: 'flex',
  alignItems: 'center',

  padding: '0.8rem',

  columnGap: '1.2rem',
});

export const LeftColumnContainer = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',

  rowGap: '1.3rem',
});

export const LeftColumnSubTitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1rem',

  color: theme.colors.base01,
}));

export const LeftColumnSubTitleItemContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const RightContainer = styled('div')(({ theme }) => ({
  height: '6.4rem',

  display: 'flex',
  alignItems: 'center',

  padding: '0 0 0 1.6rem',

  columnGap: '2rem',

  borderLeft: `0.1rem solid ${theme.colors.base05}`,
}));

type IndicatorCircleProps = {
  'data-is-passed': boolean;
};

export const IndicatorCircle = styled('div')<IndicatorCircleProps>(({ ...props }) => ({
  width: '0.8rem',
  height: '0.8rem',

  borderRadius: '50%',

  backgroundColor: props['data-is-passed'] ? '#41FF76' : '#FF4D36',
}));

export const IndicatorContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '0.6rem',
});

export const ProposalTitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,

  maxWidth: '35rem',

  wordBreak: 'keep-all',
  whiteSpace: 'nowrap',

  '& > *': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export const ProposalTitleWrapperContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,
}));
